import { makeStyles } from 'tss-react/mui'
import { fundingColors as C } from '../../theme/figmaColors'

export const useStyles = makeStyles()(() => ({
  paper: {
    boxSizing: 'border-box',
    width: 800,
    maxWidth: '92vw',
    maxHeight: '90vh',
    borderRadius: 8,
    padding: 40,
    display: 'flex',
    flexDirection: 'column',
    gap: 40,
    overflowY: 'auto',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
    width: '100%',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    minWidth: 0,
  },
  titleGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    minWidth: 0,
  },
  titleIcon: {
    width: 28,
    height: 28,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    backgroundColor: C.iconBoxBg,
    borderRadius: 4,
    '& svg': { fontSize: 16, color: C.strongText },
  },
  title: {
    fontSize: 22,
    fontWeight: 400,
    lineHeight: '28px',
    color: C.strongText,
    margin: 0,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  headerDivider: {
    width: 1,
    alignSelf: 'stretch',
    backgroundColor: C.divider,
    borderRadius: 4,
    flexShrink: 0,
  },
  help: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    flexShrink: 0,
    padding: 0,
    border: 'none',
    background: 'none',
    textDecoration: 'none',
    color: C.linkBlue,
    cursor: 'pointer',
    '& svg': { fontSize: 16 },
  },
  helpText: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    color: C.linkBlue,
    margin: 0,
    whiteSpace: 'nowrap',
  },
  close: {
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    padding: 0,
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    '& svg': { fontSize: 24, color: C.mutedText },
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    width: '100%',
  },
  warning: {
    boxSizing: 'border-box',
    backgroundColor: C.warningBg,
    borderRadius: 4,
    padding: '4px 8px',
    width: '100%',
  },
  warningText: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '16px',
    color: C.darkText,
    margin: 0,
    '& b': { fontWeight: 500 },
  },
  warningLink: {
    padding: 0,
    border: 'none',
    background: 'none',
    font: 'inherit',
    color: C.linkBlue,
    fontWeight: 500,
    letterSpacing: '0.5px',
    textDecoration: 'none',
    cursor: 'pointer',
  },
  timeline: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  event: {
    display: 'flex',
    gap: 16,
    alignItems: 'stretch',
    width: '100%',
  },
  rail: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexShrink: 0,
    width: 32,
  },
  railIcon: {
    width: 32,
    height: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    borderRadius: '50%',
    backgroundColor: C.metricBg,
    '& svg': { fontSize: 14, color: C.mutedText },
  },
  railLine: {
    flex: '1 0 0',
    minHeight: 32,
    width: 1,
    backgroundColor: C.divider,
  },
  eventBody: {
    flex: '1 1 auto',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    paddingBottom: 20,
  },
  eventTitleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    minWidth: 0,
  },
  eventTitle: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '-0.15px',
    color: C.darkText,
    margin: 0,
  },
  badge: {
    display: 'flex',
    alignItems: 'center',
    padding: '4px 8px',
    borderRadius: 9999,
    flexShrink: 0,
  },
  badgeText: {
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: '0.25px',
    margin: 0,
    color: 'inherit',
  },
  badgePositive: {
    backgroundColor: C.successBadgeBg,
    color: C.successText,
  },
  badgeNegative: {
    backgroundColor: C.warningBg,
    color: C.negBadgeText,
  },
  eventSummary: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '16px',
    color: C.mutedText,
    margin: 0,
  },
  eventTime: {
    fontSize: 11,
    fontWeight: 400,
    lineHeight: '16.5px',
    letterSpacing: '0.06px',
    color: C.mutedText,
    margin: 0,
    textAlign: 'right',
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
  empty: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    color: C.mutedText,
    margin: 0,
    textAlign: 'center',
    padding: '24px 0',
  },
}))
